<template>
    <header class=" fixed-top app-header-inter-pages dash-header page-container">
        <div class="container-fluid py-12  border-bottom px-0 ">
            <div>
                <NuxtLayout name="header" />
            </div>
        </div>
    </header>
    <main class="pt-64 px-0 announce-marks-container">
            <NuxtLayout name="marks-footer" ></NuxtLayout>
          <slot />
    </main>
    <NuxtLayout name="footer"></NuxtLayout>

</template>

